import React from 'react';

import CreateConferenceForm from '../../components/Forms/CreateConferenceForm';

const CreateConferencePage = () => <CreateConferenceForm isManaging={false} />;

export default CreateConferencePage;
